<template>
	<div class="main bg-white index">
		<div class="content-wrapper">
			<headers ref="headered"></headers>
			<div style="display:flex;flex:1;border:1px solid #f5f5f5;">
				<chatList @setDataId="setDataId" ref="chatlists"></chatList>
				<div class="chat-content">
					<div class="chat-body">
						<happy-scroll hide-horizontal resize :scroll-top="scrollTop" @vertical-start="scrollHandler">
							<div style="width: 600px; padding:20px;margin-bottom:20px;" id="chat_scroll"
								ref="scrollBox">
								<div class="chat-item" v-for="(item,index) in msglist" :key="index"
									:id="`chat_${item.id}`">
									<div class="time">{{item.create_time?item.create_time:item.show_time }}</div>
									<div :class="item.position=='left'?'flex-box':'u-f r_msg_b allnr rgs' ">
										<div class="avatar">
											<img :src="item.from_avatar" alt="">
										</div>
										<div class="mag_r">
											<div class="mc">{{item.from_nickname}}</div>
											<div class="msg_in_b">
												<div class="msg-wrapper">
													<template v-if="item.content&&item.content[0]=='{'">
														<div class="wz_b" v-if="item.msg_type=='shop'">
															<div class="s_cover"
																:style="'background:url('+item.info.cover+')'">
															</div>
															<div class="s_price">
																￥<span class="s_p_in">{{item.info.min_price}}</span>
															</div>
															<div class="s_tit">
																{{item.info.title}}</div>
															<div class="s_con">
																{{item.info.desc}}</div>
														</div>
													</template>
													<div v-else>
														<div class="content_b">
															{{item.content}}
														</div>
														<!-- <div v-if="item.msg_type=='3'">
															<img :src="`${item.content}`" alt="" width="100%">
														</div> -->
													</div>

												</div>

												<!-- <template v-if="to_user.show_user_type=='user'&&item.position!='left'">
													<div class="wd" v-if="item.is_read==2">
														未读
													</div>
													<div class="yd" v-else>
														已读
													</div>
												</template> -->

											</div>

										</div>
									</div>
								</div>
							</div>
						</happy-scroll>
					</div>
					<div class="chat-textarea">
						<!-- <div class="chat-btn-wrapper">
							<div class="left-wrapper">
								<div class="icon-item" @click.stop="isEmoji = !isEmoji">
									<i class="el-icon-user iconfont"></i>
								</div>
								<div class="icon-item" v-if="to_user">
									<el-upload class="upload-demo" action="/admin/getMediaId" accept="image/*"
										name="media" :on-success='handleSuccess' :show-file-list="false">
										<i class="el-icon-picture-outline iconfont"></i>
									</el-upload>
								</div>
								<div class="icon-item" @click.stop.stop="isMsg = true"><span
										class="iconfont iconliaotian"></span></div>
							</div>
							<div class="right-wrapper">
								<div class="icon-item">
									<span class="iconfont iconzhuanjie"></span>
									<span>转接</span>
									<!~~ <span @click="dk">断开</span> ~~>
								</div>
							</div> 
						</div> -->
						<div class="textarea-box" style="position:relative;">
							<el-input v-model="value.text" placeholder="请输入内容" type="textarea" ref="textbox" :rows="9"
								resize="none" style="font-size:14px" @keydown.native="listen($event)"></el-input>
							<div class="send-btn">
								<el-button class="btns" type="primary" v-if="to_user" @click.stop="on.send()">发送
								</el-button>
							</div>
						</div>
					</div>
				</div>
				<div class="right_b">
					<userDetail v-if="top_tabId==0" :to_user='to_user' ref="userDetail" />
					<tranOrder v-if="top_tabId==1" :to_user='to_user' ref="tranorder" />
					<orderDetail v-if="top_tabId==2" :to_user='to_order' ref="orderDetail" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import headers from "../component/header.vue";
	import chatList from "../component/chatList.vue";
	import tranOrder from "../component/tranOrder.vue";
	import userDetail from "../component/userDetail.vue";
	import orderDetail from "../component/orderDetail.vue";
	import {
		HappyScroll
	} from 'vue-happy-scroll'
	import router from "../../../router";
	export default {
		components: {
			headers,
			chatList,
			HappyScroll,
			tranOrder,
			userDetail,
			orderDetail,
		},
		data() {
			var vue = this;
			return {
				chatCon: '',
				records: [],
				scrollTop: 0,
				isScroll: true,
				upperId: 0,
				disabled: true,
				value: {
					text: '',
				},
				msglist: [],
				user_type: '',
				user_id: "",
				to_user: '',
				to_order: '',
				page: 1,
				usered: '',
				top_tabId: 0,
				on: {
					async connect(t) {
						if (t != 1) {
							setTimeout(() => {
								vue.$nextTick(async () => {
									vue.user_type = vue.$openws.user_type; //自己的type
									vue.user_id = vue.user.id;
									vue.usered = vue.user
									// vue.$refs.headered.doctor = vue.$openws.doctor
									// vue.$refs.headered.doc_id = vue.$openws.doctor.length > 0 ? vue
									// 	.$openws.doctor[0].id : ''
									// vue.$refs.chatlists.doc_id = vue.$openws.doctor.length > 0 ?
									// 	vue.$openws.doctor[0].id : ''
									vue.$refs.chatlists.getList()
									await vue.$openws.getover('chat', '')
									await vue.$refs.headered.getis_noread()
								})
							}, 1000)
						}

						vue.$openws.ws.self_msg = function (text, type) {
							// if (text.from_identity == vue.to_user.from_identity) {
							vue.msglist.push(text)
							vue.setPageScrollTo()
							vue.$refs.chatlists.getList()

							// }
						};
						vue.$openws.ws.chat_msg = function (text, type) {
							if (text.from_identity == vue.to_user.from_identity) {
								vue.msglist.push(text)
								vue.setPageScrollTo()
								vue.claerydxx(text, 1)
							}
							vue.$refs.chatlists.getList()
						}
						vue.$openws.ws.userChatList = function (text, type) {
							if (text && text.length > 0) {
								vue.$refs.chatlists.userList = text
							}
						};
						// 接诊提醒
						vue.$openws.ws.inquiryRemind = function (text, type) {
							vue.$notify.info({
								title: '新咨询订单',
								message: text.data,
								position: 'bottom-right',
							});
						};

						/*vue.$openws.ws.msg = async function (user_id, kefu_id, text) {

							// _('收到消息', user_id, text)
							if (text.xx_type == "receipt") {
								if (text.msg_type == 'user') {
									if (text.from_identity == vue.to_user.from_identity) {
										vue.msglist.forEach(ele => {
											if (ele.is_read == 2) {
												ele.is_read = 1
											}
										});
									}
								} else {
									if (text.from_identity == vue.to_user.from_identity) {
										vue.msglist[vue.msglist.length - 1].isReadCount = text.isReadCount
									}
								}

							}

							if (!text.team_id) {
								if (text.xx_type == 'self') {
									if (text.msg_source != 'homePage') {
										vue.msglist.push(text)
										vue.setPageScrollTo()
									}
								} else if (text.xx_type == 'other') {
									if (text.from_identity == vue.to_user.from_identity) {
										vue.msglist.push(text)
										vue.setPageScrollTo()
										vue.claerydxx(text, 1)
									} else {
										await vue.$refs.chatlists.getList()
										await vue.$openws.getover('chat', '')
										await vue.$refs.headered.getis_noread()
									}
								}

							} else {
								if (text.xx_type == 'self') {
									if (text.msg_source != 'homePage') {
										vue.msglist.push(text)
										vue.setPageScrollTo()
									}
								} else if (text.xx_type == 'other') {
									if (text.from_identity == vue.to_user.from_identity) {
										vue.msglist.push(text)
										vue.setPageScrollTo()
										vue.claerydxx(text, 2)
									} else {
										await vue.$refs.chatlists.getList()
										await vue.$openws.getover('chat', '')
										await vue.$refs.headered.getis_noread()
									}
								}
							}
							for (const v of vue.msglist) {
								if (v && v.content && v.content[0] == "{") {
									let d
									try {
										d = JSON.parse(v.content)
										v.type = d.type
										v.info = d
									} catch (error) {

									}
								}
							}


						};*/
					},
					send(d) {
						if (!vue.value.text) return
						var params = {
							content: vue.value.text,
							// msg_type: '1',
							from_id: vue.usered.id,
							from_avatar: vue.usered.avatar,
							from_nickname: vue.usered.username,
							from_user_type: vue.user_type,
							to_user_type: vue.to_user.show_user_type,
							to_id: vue.to_user.user_id,
							to_avatar: vue.to_user.show_avatar,
							to_nickname: vue.to_user.show_nickname,
							time: "",
							source: 4,
						}
						if (vue.$openws.ws.getState() != 1) {
							let load = vue.$message({
								message: ' 连接异常断开，正在进行重连，请稍后',
								iconClass: 'el-icon-loading',
								duration: 0
							});
							if (vue.$openws.ws && vue.$openws.ws.getState()) {
								vue.$openws.ws.close()
								setTimeout(() => {
									vue.$openws.openws()
								}, 500)

							} else {
								setTimeout(() => {
									vue.$openws.openws()
								}, 500)
							}
							setTimeout(() => {
								if (vue.$openws.ws.getState() == 1) {
									load.close()
									vue.$message.success('连接成功')
								} else {

								}
								vue.on.connect(1)
							}, 2000)
							return
						}
						let token = sessionStorage.getItem('token')
						// vue.$openws.ws.send('index/server/sendMsg', vue.to_user.show_user_id, params, `manager_${token}`)

						let obj = {
							data: params,
							type: "chatKf"
						}
						vue.$openws.ws.send(obj);

						vue.value.text = '';
						vue.$refs.chatlists.getList()
					}
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		created() {
			var vue = this;
			vue.on.connect();

		},
		mounted() {
			var vue = this;
			vue.bus.$on('selectRightMenu', data => {
				this.top_tabId = data
			})
		},
		destroyed() {
			this.$openws.connect()
		},
		methods: {
			//滚动到顶部
			scrollHandler() {
				this.page++
				this.getjlxx()
			},
			listen(e) {
				if (e.keyCode == 13) {
					e.preventDefault()
					return false
				}
			},
			//点击左边数据
			async setDataId(data) {
				this.to_user = data
				this.msglist = []
				this.isScroll = true
				this.getjlxx(1)
				this.$refs.chatlists.getList()

				let obj = {
					msg_id: data.last_msg_id,
					from_user_type: data.show_user_type,
					from_id: data.show_user_id,
					to_user_type: this.$openws.user_type,
					to_id: this.$refs.headered.doc_id,
				}
				let obj2 = {
					msg_id: data.last_msg_id,
					from_user_type: 'team',
					from_id: this.$openws.user_id,
					to_id: data.show_user_id,
					to_user_type: data.show_user_type,
				}

				// if (data.no_read > 0) {
				// 	this.claerydxx(!data.team_id ? obj : obj2, !data.team_id ? 1 : 2)
				// }
				await this.$openws.getover('chat', 'clear')
				// await this.$refs.headered.getis_noread()



				if (this.top_tabId == 0) {
					this.$nextTick(() => {
						this.$refs.userDetail.getList()
					})
				} else if (this.top_tabId == 1) {
					this.$nextTick(() => {
						this.$refs.tranorder.getList()
					})
				} else if (this.top_tabId == 2) {
					this.$nextTick(() => {
						this.$refs.headered.selectTab({
							key: 1,
							title: '交易订单',
						})
					})

				}

			},
			// 聊天记录
			getjlxx(t) {
				let vue = this
				axios.post('/admin/userChat/getHistroyList', {
					page: this.page,
					page_count: 10,
					user_id: this.to_user.user_id,
					from_id: this.to_user.user_id,
					from_user_type: vue.to_user.show_user_type,
					// to_user_type: vue.user_type,
				}, {
					token: true
				}).then(res => {
					var lists = res.data.data.list
					this.msglist = [...lists, ...this.msglist];
					for (const v of this.msglist) {
						if (v && v.content && v.content[0] == "{") {
							let d
							try {
								d = JSON.parse(v.content)
								v.type = d.type
								v.info = d
							} catch (error) {

							}
						}
					}
					if (t == 1) {
						vue.setPageScrollTo()
					}
				})
			},
			// 清除已读消息
			claerydxx(data, t) {
				// let vue = this
				// let params = {
				// 	msg_id: data.msg_id,
				// 	from_user_type: data.from_user_type,
				// 	from_id: data.from_id,
				// 	to_user_type: data.to_user_type,
				// 	to_id: data.to_id,
				// }
				// let params2 = {
				// 	msg_id: data.msg_id,
				// 	from_user_type: 'team',
				// 	from_id: vue.usered.id,
				// 	to_id: data.to_id,
				// 	to_user_type: data.to_user_type,
				// }
				// vue.$openws.ws.send('index/server/msgReceipt', t == 1 ? params : params2)

				let vue = this
				let obj = {
					data: {
						source: 4,
						user_id: this.user.id,
						to_id: data.from_id
					},
					type: "to_chat"
				}
				vue.$openws.ws.send(obj);
			},
			// 设置页面滚动位置
			setPageScrollTo() {
				this.$nextTick(() => {
					this.scrollTop = document.querySelector("#chat_scroll").offsetHeight
					setTimeout(res => {
						if (this.scrollTop != this.$refs.scrollBox.offsetHeight) {
							this.scrollTop = document.querySelector("#chat_scroll").offsetHeight
						}
					}, 300)
				})
			},
			handleSuccess(file) {
				let vue = this
				let token = sessionStorage.getItem('token')
				if (file.code == '200') {
					var params = {
						text: file.data.url,
						msg_type: 3,
						from_id: vue.usered.id,
						from_avatar: vue.usered.avatar,
						from_nickname: vue.usered.nickname,
						from_user_type: vue.user_type,
						to_user_type: vue.to_user.show_user_type,
						to_id: vue.to_user.show_user_id,
						to_avatar: vue.to_user.show_avatar,
						to_nickname: vue.to_user.show_nickname,
						time: "",
						media_id: file.data.media_id
					}
					vue.$openws.ws.send('index/server/sendMsg', vue.to_user.show_user_id, params, `manager_${token}`)
				}

			},
			selectorder(item) {
				this.to_order = item
				this.$nextTick(() => {
					this.$refs.orderDetail.getList()
				})
			},
			dk() {
				this.$openws.ws.close()
				this.$message('已断开')
			},

		}
	}
</script>


<style lang="scss" scoped>
	.main {
		margin: -1rem -20px -60px -20px;
		height: calc(100% + 25px);

		.bls {
			height: 100%;
			display: flex;

			.bl1 {
				width: 200px;

				.lis {
					.ite {
						&.on {
							color: red;
						}
					}
				}
			}

			.bl2 {
				flex: 1;
				width: 0;
				border-left: 1px solid #ccc;
				border-right: 1px solid #ccc;
				display: flex;
				flex-flow: column;

				.msgs {
					flex: 1;
					height: 0;
				}

				.bd {
					.conn {
						display: flex;

						.in {
							flex: 1;
						}
					}
				}
			}

			.bl3 {
				width: 200px;
			}
		}
	}

	.content-wrapper {
		display: flex;
		flex-direction: column;
		width: 1200px;
		height: 808px;
		margin: 0 auto;
		background: #fff;
	}

	.chat-content {
		width: 600px;
		height: 100%;
		border-right: 1px solid #ECECEC;

		.chat-body {
			height: 530px;

			.chat-item {
				padding-bottom: 24px;

				.time {
					text-align: center;
					color: #999999;
					font-size: 14px;
					margin: 18px 0;
				}

				.flex-box {
					display: flex;

					.mag_r {
						display: flex;
						flex-direction: column;
						align-items: flex-start;
					}

					.msg_in_b {
						display: flex;
						align-items: flex-start;
					}
				}

				.r_msg_b {
					.mag_r {
						display: flex;
						flex-direction: column;
						align-items: flex-end;
					}

					.msg_in_b {
						display: flex;
						// align-items: flex-end;
						flex-direction: row-reverse;

					}
				}

				.rgs {
					flex-direction: row-reverse;
				}

				.avatar {
					width: 40px;
					height: 40px;
					margin-right: 16px;

					img {
						display: block;
						width: 100%;
						height: 100%;
						border-radius: 50%;
					}
				}



				.mc {
					color: #b2b2b2;
					font-size: 13px;
				}


				.msg-wrapper {
					max-width: 320px;
					background: #f8f8f8;
					border-radius: 5px;
					color: #000000;
					font-size: 14px;
					overflow: hidden;
					padding: 5px;

					.txt-wrapper {
						word-break: break-all;
					}

					.pad16 {
						padding: 9px;
					}

					.img-wraper img {
						max-width: 100%;
						height: auto;
						display: block;
					}

					.order-wrapper {
						display: flex;
						width: 320px;

						.img-box {
							width: 60px;
							height: 60px;

							img {
								width: 100%;
								height: 100%;
								border-radius: 5px;
							}
						}

						.order-info {
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							width: 224px;
							margin-left: 10px;
							font-size: 12px;

							.price-box {
								display: flex;
								align-items: center;
								justify-content: space-between;
								font-size: 14px;
								color: #FF0000;

								.more {
									font-size: 12px;
									color: #1890FF;
								}
							}
						}

						.name {
							font-size: 14px;
						}

						.sku {
							margin: 1px 0;
							color: #999999;
						}
					}
				}

				.wd {
					// background-color: #f8f8f8;
					color: #999;
					font-size: 12px;
					padding: 0 5px;
				}

				.yd {
					// background-color: #f8f8f8;
					color: #89C659;
					font-size: 12px;
					padding: 0 5px;

				}

				.right-box {
					.flex-box {
						flex-direction: row-reverse;

						.avatar {
							margin-right: 0;
							margin-left: 16px;
						}

						.msg-wrapper {
							background: #CDE0FF
						}

					}

					.gary .msg-wrapper {
						background: #f5f5f5
					}

				}

				.content_b {
					word-break: break-all;
				}

				.sharewz_b {

					.wz_img {
						margin-right: 5px;

						/deep/ div {
							display: block;
						}
					}

					.wz_info {
						flex: 1;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;

						.wztit {
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							font-size: 16px;
						}

						.wzcons {
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
							white-space: normal;
							font-size: 14px;
							color: #5f5f5f;
						}
					}
				}

				.wz_b {
					.s_cover {
						width: 100%;
						padding-top: 100%;
						background-size: cover !important;
						background-repeat: no-repeat !important;
						background-position: center !important;
						border-radius: 5px;
					}

					.s_price {
						color: red;
						font-size: 12px;
						padding: 3px 0;

						.s_p_in {
							font-size: 14px;
						}
					}

					.s_tit {
						font-size: 14px;

					}

					.s_con {
						color: #999;
						font-size: 12px;
					}
				}
			}
		}
	}

	.right_b {
		flex: 1;
	}

	.chat-textarea {
		height: 214px;
		border-top: 1px solid #ECECEC;

		.chat-btn-wrapper {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 15px 0;
		}

		.left-wrapper {
			display: flex;
			align-items: flex-start;

			.icon-item {
				display: flex;
				align-items: center;
				margin-left: 20px;
				cursor: pointer;

				.iconfont {
					font-size: 22px;
					color: #333333;
				}
			}
		}

		.right-wrapper {
			position: relative;
			padding-right: 20px;

			.icon-item {
				display: flex;
				align-items: center;
				font-size: 15px;
				color: #333;
				cursor: pointer;

				span {
					margin-left: 10px;
				}
			}

			.transfer-box {
				z-index: 60;
				position: absolute;
				right: 1px;
				bottom: 43px;
				width: 140px;
				background: #fff;
				box-shadow: 0 4px 12px rgba(0, 0, 0, .15);
				padding: 16px;
			}

			.transfer-bg {
				z-index: 50;
				position: fixed;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				background: transparent;
			}
		}

		.emoji-box {
			position: absolute;
			left: 0;
			top: 0;
			transform: translateY(-100%);
			display: flex;
			flex-wrap: wrap;
			width: 60%;
			padding: 15px 9px;
			box-shadow: 0px 0px 13px 1px rgba(0, 0, 0, .1);
			background: #fff;

			.emoji-item {
				margin-right: 13px;
				margin-bottom: 8px;
				cursor: pointer;

				&:nth-child(10n) {
					margin-right: 0;
				}

			}
		}
	}

	.send-btn {
		position: absolute;
		right: 0;
		bottom: 10px;
		display: flex;
		justify-content: flex-end;
		margin-top: 10px;
		margin-right: 10px;
		width: 80px;

		.btns {
			width: 100%;
			background: #3875EA;
		}
	}
</style>